import * as ApiManager from './_manager'
import store from '../store';


export const tag = {

    list: (payload) => {
        return ApiManager.callApi (`/member/company/${store.getters['company/getSelected']}/tag/list`, payload);
    },

    listAll: (payload) => {
        return ApiManager.callApi(`/member/company/${store.getters['company/getSelected']}/tag/all/list`, payload);
    },

    getTags: (payload) => {
        return ApiManager.callApi (`/member/company/${store.getters['company/getSelected']}/tag/model/getTags`, payload);
    },

    syncTag: (payload) => {
        return ApiManager.callApi (`/member/company/${store.getters['company/getSelected']}/tag/model/syncTags`, payload);
    },
}
